
(function(){
  const modalclose = document.getElementById('yy-promo-close');
  const modal = document.getElementById('yy-promoModal');
  const moverlay = document.getElementById('gf-popupOverlay1702704784868');
 

  // close modal
  function closeModal(){
    modal.style.display = 'none';
    moverlay.style.display = 'none';
    moverlay.style.background = 'none';
    moverlay.style.opacity = 0;
    console.log('popup closed done');

  }

  // click to close (backdrop or close button)
  modalclose?.addEventListener('click', function(e){
     closeModal(); 
  });



  })();